// cleanup_hoc_to_hooks_GENERICS
// cleanup_convert_to_typescript_file_GENERICS

import React, { useState, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { withTheme } from '@glu/theming';
import { Button, TERTIARY } from '@glu/buttons-react';

import SideNav from 'components/sideNav/SideNavContainer';
import useLocale from 'components/useLocale';
import Routing from 'config/routing/Routing';
import Snackbar from 'components/snackbarMgr/SnackbarMgr';
import UserPreferencesProvider from 'components/withUserPreferences/UserPreferencesProvider';
import UserEmulationNotification from 'components/userEmulation/UserEmulationNotification';
import { KEY_NAMES } from 'constants.js';

import useStyles from './App.styles';

const { SPACE } = KEY_NAMES;

export const AppComponent = ({ user }) => {
  const { app, container, skipLink } = useStyles();
  const appRef = createRef(null);
  const [top, setPosition] = useState(null);
  const locale = useLocale();

  return (
    <UserPreferencesProvider>
      {user.emulationSession && <UserEmulationNotification setPosition={setPosition} />}
      <div ref={appRef} className={classnames(container, 'app')} style={{ top }}>
        <Button
          className={classnames('btn btn-tertiary', skipLink)}
          component="a"
          href="#content"
          onKeyDown={(event) => {
            if (event.key === SPACE) {
              event.preventDefault();
            }
          }}
          variant={TERTIARY}
        >
          {locale['common.skipLink']}
        </Button>
        <SideNav />
        <div className={`${app} glu`} data-qa="app-content">
          {/* Routing section */}
          <div className={`glu-content ${container}`}>
            <div role="presentation" className="row">
              <Routing />
            </div>
          </div>
        </div>
        <Snackbar />
      </div>
    </UserPreferencesProvider>
  );
};

AppComponent.propTypes = {
  user: PropTypes.shape({}).isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({
  user: state.auth.user
});

export default connect(mapStateToProps, null)(withTheme(AppComponent));
